<nav
  [show]="isOpen()"
  class="vertical-navigation-menu"
  motif-vertical-navigation>
  <ul motif-vertical-navigation-menu position="top">
    @for (link of filteredTopLinks(); track link) {
      <li motif-vertical-navigation-menu-item>
        <a
          class="menu-item"
          motif-vertical-navigation-menu-link
          [routerLink]="link.route"
          vertical-navigation-menu-item-active
          [verticalNavigationMenuItemActiveOptions]="{ exact: false }"
          [ngClass]="{
            'no-icon-padding': !link.icon,
            disabled: link.disabled,
          }">
          @if (link.icon) {
            <motif-icon [iconFunction]="link.icon"></motif-icon>
          }
          <span>{{ link.label | translate }}</span>
        </a>
      </li>
    }
  </ul>
</nav>
